import { css } from 'emotion';

export const image = css(`
	:lang(ar) {
		transform: scaleX(-1);
		direction: rtl;
	}
	max-width: 100%;
	transition: opacity 0.6s;
`);
